import { gql } from 'graphql-query-contracts';

export const listUnits = gql(`
  query ListUnits($propertyId: UUID!) {
    property(propertyId: $propertyId) {
      units {
        id
        name
        description
        floors {
          id
          index
          name
        }
      }
    }
  }
`);
